module.exports = __webpack_public_path__ + "img/service-icon-fan.e687f163.png";